// menu.service.ts
import { Injectable } from '@angular/core'
import { MENU_ITEMS, MenuItemType } from '../common/menu-items'

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  constructor() {}

  getAppMenuItems() {
    return MENU_ITEMS
  }

  getActiveClass(activeMenuItems: string[], key: string): string {
    const isActive = activeMenuItems.includes(key)
    return isActive ? 'active' : ''
  }

  findAllParent(menuItems: any[], menuItem: any): string[] {
    let parents: string[] = []
    if (menuItem.parentKey) {
      const parent = this.findMenuItem(menuItems, menuItem.parentKey)
      if (parent) {
        parents.push(parent.key)
        if (parent.parentKey) {
          parents = [...parents, ...this.findAllParent(menuItems, parent)]
        }
      }
    }
    return parents
  }

  getMenuItemFromURL(menuItems: MenuItemType[], url: string): MenuItemType | undefined {
    const normalizeUrl = (url: string) => url.replace(/^\/+/, '/').replace(/\/+$/, ''); // Normalize URL
  
    const normalizedUrl = normalizeUrl(url);
    console.log('Searching for URL:', normalizedUrl);
    console.log('Menu Items:', menuItems);
  
    for (const item of menuItems) {
      // Normalize menu item URLs for comparison
      const itemUrl = normalizeUrl(item.url || '');
      
      if (itemUrl === normalizedUrl) {
        console.log('Match found:', item);
        return item;
      }
      if (item.children) {
        console.log(`Checking children of: ${item.label}`);
        const child = this.getMenuItemFromURL(item.children, normalizedUrl);
        if (child) {
          return child;
        }
      }
    }
  
    console.warn('No matching menu item for URL:', normalizedUrl);
    return undefined;
  }

  findMenuItem(menuItems: any[], menuItemKey: string): any {
    for (const element of menuItems) {
      if (element.key === menuItemKey) {
        return element
      }
      if (element.children) {
        const found = this.findMenuItem(element.children, menuItemKey)
        if (found) return found
      }
    }
    return null
  }
}
